import { useForm } from "react-hook-form";
import { useTranslation } from "@privacy/translations";
import { useMutation } from "@tanstack/react-query";
import { DynamicForm } from "../../dynamicForm";
import { ErrorMessage } from "../../dynamicForm/inlineForm/ErrorMessage";
import { updateDpiaMutationOptions } from "../../api/dpia";
import type { DpiaById } from "../../api/dpia.types";

export const DpiaSummaryField = ({ dpia, isReadOnly }: { dpia: DpiaById; isReadOnly: boolean }) => {
  const { t } = useTranslation();
  const updateDpiaMutation = useMutation(updateDpiaMutationOptions());
  const form = useForm({ values: { summary: dpia.summary ?? "" } });

  return (
    <DynamicForm.InlineFieldPrimary
      htmlFor="summary"
      label={t("DpiaDrawer.Summary.Label")}
      input={
        <DynamicForm.StyledInlineTextInput
          id="summary"
          form={form}
          numberOfRows={3}
          isReadOnly={isReadOnly}
          onSave={value => updateDpiaMutation.mutateAsync({ id: dpia.id, payload: { summary: value } })}
          renderErrorMessage={({ isSaving, isSaveError }) => !isSaving && isSaveError && <ErrorMessage />}
        />
      }
    />
  );
};
